import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { updateAssessmentSlotStatus } from "../../api/assessmentslots.api";
interface AssessmentItem {
  id: string;
  assessmentName: string;
  roleName: string;
  roleStatus: string;
  dateTime: string;
  endTime: string | null;
  computedStatus: string;
}

interface AssessmentTestRowProps {
  assessment: AssessmentItem;
}

const AssessmentTestRow: React.FC<AssessmentTestRowProps> = ({
  assessment,
}) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const isActive = Boolean(assessment.roleStatus);

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "Active":
        return (
          <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
            Active
          </span>
        );
      case "Scheduled":
        return (
          <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">
            Scheduled
          </span>
        );
      case "Expired":
        return (
          <span className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-600/20">
            Expired
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20">
            Inactive
          </span>
        );
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleNavigate = () => {
    navigate(`/tests/${assessment.id}/candidates`);
  };

 
  const formatDateTime = (dateStr: string) => {
    if (!dateStr) return "";
    const hasExplicitTz = /([zZ]|[+\-]\d{2}:?\d{2})$/.test(dateStr);
    const utcString = hasExplicitTz ? dateStr : `${dateStr}Z`;

    const date = new Date(utcString);
    if (isNaN(date.getTime())) return "Invalid date";

    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12

    const formatted = `${day} ${month} ${year}, ${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
    return formatted;
  };

  return (
    <div className="border-b border-gray-200 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 dark:border-gray-800">
      <div
        className="sm:flex sm:items-baseline sm:justify-between hover:bg-gradient-to-r from-white via-gray-200 to-white pl-2 py-4 rounded-sm dark:from-darkbg dark:via-darkbglight dark:to-darkbg cursor-pointer"
        onClick={handleNavigate}
      >
        <div className="flex items-start gap-3 sm:w-full sm:flex-1">
          <div className="grid grid-cols-3 flex-1">
            <div className="col-span-2">
              <h1
                id="message-heading"
                className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-300"
              >
                <span className="flex flex-row items-center gap-2">
                  {assessment.assessmentName}
                </span>
              </h1>
              <div className="mt-2 flex items-center text-sm text-gray-500">
                <span className="mr-1.5">Role:</span>
                {assessment.roleName}
              </div>
            </div>
            <div>
              <h1
                id="message-heading"
                className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-400"
              >
                <span>Scheduled Time</span>
              </h1>
              <div className="mt-2 flex items-center text-sm text-gray-500">
                {formatDateTime(assessment.dateTime)}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 mb-0 flex items-center justify-between sm:ml-6 sm:mt-0 sm:flex-shrink-0 sm:justify-start">
          {getStatusBadge(assessment.computedStatus || (isActive ? "Active" : "Inactive"))}

          
        </div>
      </div>
    </div>
  );
};

export default AssessmentTestRow;